import React, {useContext, useEffect, useMemo, useState} from 'react';
import ItemForm from "./ItemForm";
import {observer} from "mobx-react-lite";
import {updateItem} from "../../http/itemsAPI";
import {Context} from "../../index";
import {catalogItemId} from "../../util/catalogItemId";
import {imageFilenameFromApiUrl, itemImageSrc} from "../../util/imageUrl";

const ItemUpdate = observer(({oldItem, show, onHide, onSaved}) => {
    const {items} = useContext(Context)
    const [uploadFiles, setUploadFiles] = useState([])
    const [keptFilenames, setKeptFilenames] = useState([])
    const [item, setItem] = useState({
        id: undefined,
        category: '',
        title: '',
        price: 0,
        count: 0,
        description: '',
    })

    const existingPreviews = useMemo(() => {
        if (!oldItem) return []
        const urls = oldItem?.imageUrls || []
        const fromUrls = urls
            .map((u, i) => {
                const filename = imageFilenameFromApiUrl(u)
                return {filename, url: itemImageSrc(oldItem, i)}
            })
            .filter((p) => p.filename)
        if (fromUrls.length > 0) return fromUrls

        const imgs = oldItem?.images || []
        return imgs
            .map((img, i) => ({
                filename: img.filename,
                url: itemImageSrc(oldItem, i),
            }))
            .filter((p) => p.filename)
    }, [oldItem])

    useEffect(() => {
        if (show && oldItem) {
            setItem({
                id: catalogItemId(oldItem),
                category: oldItem.categoryResponse?.title ?? '',
                title: oldItem.title,
                price: oldItem.price,
                count: oldItem.count,
                description: oldItem.description,
            })
            const fromUrls = (oldItem.imageUrls || []).map(imageFilenameFromApiUrl).filter(Boolean)
            const fromImages = (oldItem.images || []).map((img) => img.filename).filter(Boolean)
            setKeptFilenames([...new Set([...fromUrls, ...fromImages])])
            setUploadFiles([])
        }
    }, [show, oldItem])

    const update = async () => {
        if (keptFilenames.length + uploadFiles.length < 1) {
            alert('Нужна минимум одна фотография (оставьте текущую или добавьте новую).')
            return
        }
        updateItem(item, uploadFiles, keptFilenames)
            .then(() => {
                setUploadFiles([])
                onSaved?.()
                onHide()
            })
            .catch((error) =>
                alert(error.response?.data?.message || error.message || 'Ошибка обновления товара'),
            )
    }

    if (!show || !oldItem) {
        return null
    }

    return (
        <ItemForm
            variant="update"
            show={show}
            onHide={() => {
                setUploadFiles([])
                onHide()
            }}
            sendRequest={update}
            item={item}
            setItem={setItem}
            items={items}
            existingPreviews={existingPreviews}
            keptFilenames={keptFilenames}
            setKeptFilenames={setKeptFilenames}
            uploadFiles={uploadFiles}
            setUploadFiles={setUploadFiles}
        />
    );
});

export default ItemUpdate;
